import React from "react";
import "./Press.css";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";

function Press() {
  return (
    <div className="press">
      <div className="container">
        <div className="press_text">
          <h1>Press</h1>
          <hr />
          <Container>
            <Row>
              <Col md={6}>
                <Card>
                  <Card.Header className='press-header'>
                    Emotional Resiliency With K'Bro App
                  </Card.Header>
                  <Card.Img
                    className='press-image'
                    src="/images/pressSeven.jpeg"
                    alt="Podcast"
                  />
                  <a
                    href="https://on-boys.blubrry.net/emotional-resililency-with-kbro-app/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Footer className="press-card-footer">READ MORE...</Card.Footer>
                  </a>
                </Card>
              </Col>
              <Col md={6}>
                <Card>
                  <Card.Header className='press-header'>
                    Healthcare innovation projects in context health
                  </Card.Header>
                  <Card.Img
                    className='press-image'
                    src="/images/pressOne.jpg"
                    alt="Day one conference project summaries"
                  />
                   <a
                    href="https://www.slideshare.net/dayonebasel/dayone-conference-projects-169969877"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Footer className="press-card-footer">READ MORE...</Card.Footer>
                  </a>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Card>
                  <Card.Header className='press-header'>
                    Tools to help burnout attention problems
                  </Card.Header>
                  <Card.Img
                    src="/images/pressSix.jpg"
                    alt="Woman with shaved hair, green jacket, eyes closed and crying in front of microphones"
                  />
                  <a
                    href="https://psychnews.psychiatryonline.org/doi/10.1176/appi.pn.2019.7b6"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Footer className="press-card-footer">READ MORE...</Card.Footer>
                  </a>
                </Card>
              </Col>
            
              <Col md={6}>
                <Card>
                  <Card.Header className='press-header'>
                    APA 'Shark Tank' Takes a Deep Dive Into Mental Health Care
                    Solutions
                  </Card.Header>
                  <Card.Img
                    src="/images/pressThree.jpg"
                    alt="Woman with long dark hair and white sweater holding hands over face while woman screams in the background"
                  />
                  <a
                    href="https://www.medscape.com/viewarticle/896173"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Footer className="press-card-footer">READ MORE...</Card.Footer>
                  </a>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Card>
                  <Card.Header className='press-header'>
                    YouROK’s app K’Bro Selected as Finalist for 2019 APA
                    Innovation Lab
                  </Card.Header>
                  <Card.Img
                    src="/images/pressFour.png"
                    alt="Screen capture of K Bro App"
                  />
                  <a
                    href="https://www.prdistribution.com/news/youroks-app-kbro-selected-as-finalist-for-2019-apa-innovation-lab/6738103"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Footer className="press-card-footer">READ MORE...</Card.Footer>
                  </a>
                </Card>
              </Col>

              <Col md={6}>
                <Card>
                  <Card.Header className='press-header'>
                    Help Teens Cope with Stress from Stoneman Douglas Shooting
                  </Card.Header>
                  <Card.Img
                    src="/images/pressFive.jpg"
                    alt="School age children hugging with tears in eyes"
                  />
                  <a
                    href="https://www.pr.com/press-release/745637"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Card.Footer className="press-card-footer">READ MORE...</Card.Footer>
                  </a>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default Press;
